import Gifts from './Gifts';
import MorePointsPage from './morePoints/MorePointsPage';
import GiftOrderFlow from './order/GiftOrderFlow';

export const giftsRoutes = [
  {path: '/gifts/order/:giftId/:step?', name: 'GiftOrderFlow', Component: GiftOrderFlow},
  {path: '/gifts/more-points', name: 'MorePoints', Component: MorePointsPage},
  {path: '/gifts', name: 'Gifts', Component: Gifts},
];
